import { RecConfig, getParse_rec_list } from './RecConfig';

// 收银台
const Config = {
  'pay_success.backhp': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'backhp',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { u } = traceData;
        return { u };
      },
    },
  },
  'pay_success.order_detail': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'order_detail',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData;
      },
    },
  },
  'pay_success.share': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'share',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'pay_success.sheet_share': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'sheet_share',
    },
    d: {
      type: 'variable',
      func: ({ d }) => {
        return d;
      },
    },
  },
  'pay_success.notify': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'notify',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'pay_success.success_banner': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'success_banner',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData;
      },
    },
  },
  'pay_success.recommend_list': {
    operation: ['VISIBLE', 'TOUCH'],
    // c: {
    //     type: 'constant',
    //     value: 'recommend_list',
    // },
    // d: {
    //     type: 'constant',
    //     value: '1',
    // },
    // iid: {
    //     type: 'variable',
    //     func: function getIid(traceData) {
    //         const { u, order_id } = traceData;
    //         return 'u=' + u + '&order_id=' + order_id;
    //     },
    // },
    // getParse: getParse_rec_list,
    getParse_rec_list,
  },
  'pay_success.surprise_popups': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'surprise_popups',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'pay_success.coupon_use': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'coupon_use',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        delete traceData.d;
        return traceData;
      },
    },
  },
  'pay_success.surprise_popups_close': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'surprise_popups_close',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'pay_success.common_popups': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'common_popups',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData;
      },
    },
  },
  'pay_success.common_popups_close': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: ' common_popups_close',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData;
      },
    },
  },
  'pay_success.point_prompt': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'point_prompt',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return { u: traceData.u };
      },
    },
  },
};

export default Config;
